(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rully-community-scroll"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rully-community-slider').forEach(function (root) {
    const track = root.querySelector('.rully-community-slider__track');
    if (!track || track.dataset.rullyInit) return;
    track.dataset.rullyInit = 'true';

    const pxPerSecond = parseFloat(root.dataset.speedPxPerSec) || 40;
    let offset = 0;
    let halfWidth = 0;
    let lastTime = null;
    let running = true;

    function measure() {
      halfWidth = track.scrollWidth / 2;
    }
    measure();
    window.addEventListener('resize', measure);

    function step(timestamp) {
      if (!running) return;
      if (lastTime === null) lastTime = timestamp;
      const delta = (timestamp - lastTime) / 1000;
      lastTime = timestamp;

      offset -= pxPerSecond * delta;
      if (Math.abs(offset) >= halfWidth) {
        offset += halfWidth;
      }
      track.style.transform = 'translate3d(' + offset + 'px,0,0)';
      requestAnimationFrame(step);
    }

    // Pause when off-screen to save battery, resume when visible
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          running = entry.isIntersecting;
          if (running) {
            lastTime = null;
            requestAnimationFrame(step);
          }
        });
      }, { threshold: 0 });
      observer.observe(root);
    } else {
      requestAnimationFrame(step);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
